import AllIntegrationLogs from './components/all-integration-logs/AllIntegrationLogs.vue'
import Integrations from './components/integrations/Integrations.vue'
import ShowLog from './components/show-log/ShowLog.vue'

const MonitoringRoutes = [
  {
    path: 'integrations',
    name: 'monitoring.routes.integrations',
    component: Integrations
  },
  {
    path: 'all-integration-logs',
    name: 'monitoring.routes.all_integration_logs',
    component: AllIntegrationLogs
  },
  {
    path: 'show-log',
    name: 'monitoring.routes.show_log',
    component: ShowLog
  }
]

export default MonitoringRoutes
